import { FilButton } from '@fil-global/fil-button/src/index.js';
import customStyles from './fil-button.styles';

export class FilButtonExtended extends FilButton {
  static get styles() {
    return [...super.styles, customStyles];
  }
}
